import { schema } from 'normalizr';

export const productSchema = new schema.Entity('products', {});
export const arrayOfProductSchemas = new schema.Array(productSchema);



// WEBPACK FOOTER //
// ./src/schemas/products.js